import IndicatorEvolutionEmbedPage from './IndicatorEvolutionEmbedPage';
import { withRouter } from 'react-router'

export default withRouter(IndicatorEvolutionEmbedPage);


// WEBPACK FOOTER //
// ./src/pages/IndicatorEvolutionEmbedPage/index.js